import { useToast } from "vue-toastification";
import { i18n } from "@/i18n";

/**
 * Open a file dialog and return the selected file.
 */
export async function openFile(fileTypes: string[] = ["image/*"]) {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = fileTypes.join(",");

  const promise = new Promise<File>((resolve, reject) => {
    input.onchange = async (e) => {
      const files = (e.target as HTMLInputElement).files;
      if (!files || files.length == 0) {
        reject("No file selected");
        return;
      }

      const file = files[0];
      resolve(file);
    };

    input.click();
  });

  return promise;
}

export async function getDataUrlDimensions(
  dataUrl: string,
  fileType: string
): Promise<{ width: number, height: number }> {
  const type = fileType.split("/")[0];
  if (type == "image") {
    const img = new Image();
    const promise = new Promise<{ width: number; height: number; }>((resolve, reject) => {
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = () => {
        reject("Failed to load image");
      }
    });
    img.src = dataUrl;
    return promise;
  } else if (type == "video") {
    const video = document.createElement("video");
    const promise = new Promise<{ width: number; height: number; }>((resolve, reject) => {
      video.onloadedmetadata = () => {
        resolve({ width: video.videoWidth, height: video.videoHeight });
      };
      video.onerror = () => {
        console.log("could not load video", video.error);
        reject("Failed to load video");
      }
    });
    video.src = dataUrl;
    return promise;
  }

  throw new Error(`Invalid file type: ${type}`);
}

/**
 * Converts a file to a data URL.
 */
export async function fileToDataURL(file: File | Blob): Promise<string> {
  const reader = new FileReader();
  const promise = new Promise<string>((resolve, reject) => {
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = (e) => {
      console.error("Error reading file", e);
      reject(e);
    };
  });

  reader.readAsDataURL(file);
  return promise;
}


export function warnIfFileIsLarge(file: File | Blob, maxSizeMB: number = 4) {
  const toast = useToast();
  const fileSize = file.size / 1024 / 1024; // size in MB
  if (fileSize > maxSizeMB) {
    toast.warning(i18n.t("messages.largeFileNotice", { size: fileSize.toFixed(2)}), {
      timeout: 5000,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  }
  return fileSize;
}